import React from 'react'
import PropTypes from 'prop-types'
import Modal, { ModalBody, ModalFooter } from '../Modal'
import ButtonGroup from '../ButtonGroup'
import Button from '../Button'
import * as translationService from './../../services/translationService'
import DisplayText from '../DisplayText'

const ConfirmModal = ({ message, onCancel, onConfirm, cancelAction, confirmAction, ...rest }) => {
  const handleCancel = () => {
    onCancel && onCancel()
  }
  const handleConfirm = () => {
    onConfirm && onConfirm()
  }

  return (
    <Modal shouldCloseOnOverlayClick={false} onRequestClose={handleCancel} isCompact {...rest}>
      <ModalBody id="sceneModal">
        <DisplayText size="small">{message}</DisplayText>
      </ModalBody>
      <ModalFooter>
        <ButtonGroup>
          <Button onClick={handleCancel}>{cancelAction ? cancelAction : translationService.buttonCancel()}</Button>
          <Button onClick={handleConfirm} primary>
            {confirmAction ? confirmAction : translationService.buttonConfirm()}
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelAction: PropTypes.string,
  confirmAction: PropTypes.string,
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/ConfirmModal.js